const DATABASE_NAME = 'mcFileUploads'
const DATABASE_VERSION = 1
const STORE_NAME = 'fileHandles'

const openDatabase = () =>
  new Promise((resolve, reject) => {
    if (!window.indexedDB) {
      reject(new Error('IndexedDB tidak didukung'))
      return
    }

    const request = window.indexedDB.open(DATABASE_NAME, DATABASE_VERSION)
    request.onupgradeneeded = () => {
      const database = request.result
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        database.createObjectStore(STORE_NAME)
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })

const runTransaction = async (mode, operation) => {
  const database = await openDatabase()

  return new Promise((resolve, reject) => {
    const transaction = database.transaction(STORE_NAME, mode)
    const store = transaction.objectStore(STORE_NAME)
    const request = operation(store)

    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
    transaction.oncomplete = () => database.close()
    transaction.onerror = () => {
      database.close()
      reject(transaction.error)
    }
  })
}

export const supportsPersistentFileHandle = () =>
  typeof window !== 'undefined' && 'showOpenFilePicker' in window && 'indexedDB' in window

export const saveUploadFileHandle = (uploadId, fileHandle) =>
  runTransaction('readwrite', (store) => store.put(fileHandle, uploadId))

export const getUploadFileHandle = (uploadId) =>
  runTransaction('readonly', (store) => store.get(uploadId))

export const deleteUploadFileHandle = (uploadId) =>
  runTransaction('readwrite', (store) => store.delete(uploadId))
